function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, Popper, SearchInput, Tooltip } from '@deephaven/components';
import { dhGearFilled, dhCheckSquare, dhSquareFilled, dhRemoveSquareFilled, dhWarningCircleFilled, vsCircleLargeFilled } from '@deephaven/icons';
import { TableUtils } from '@deephaven/jsapi-utils';
import "./CrossColumnSearch.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
class CrossColumnSearch extends PureComponent {
  static createSearchFilter(dh, searchValue, selectedColumns, columns, invertSelection) {
    var filterColumns = invertSelection ? columns.filter(column => !selectedColumns.includes(column.name)).map(column => column.name) : selectedColumns;
    if (searchValue && filterColumns.length > 0) {
      var filterValue = dh.FilterValue.ofString(searchValue);
      var searchFilter = filterColumns.length === columns.length ? dh.FilterCondition.search(filterValue) : dh.FilterCondition.search(filterValue, columns.filter(column => filterColumns.includes(column.name)).map(column => column.filter()));
      return searchFilter;
    }
    return undefined;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "searchField", void 0);
    this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
    this.toggleColumn = this.toggleColumn.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.clear = this.clear.bind(this);
    this.selectNumbers = this.selectNumbers.bind(this);
    this.searchField = /*#__PURE__*/React.createRef();
    this.state = {
      isConfigureColumnsShown: false
    };
  }
  focus() {
    var _this$searchField$cur;
    (_this$searchField$cur = this.searchField.current) === null || _this$searchField$cur === void 0 || _this$searchField$cur.focus();
  }
  handleSearchValueChange(event) {
    var _this$props = this.props,
      onChange = _this$props.onChange,
      selectedColumns = _this$props.selectedColumns,
      invertSelection = _this$props.invertSelection;
    onChange(event.target.value, selectedColumns, invertSelection);
  }
  sendColumnChange(selectedColumns, invertSelection) {
    var _this$props2 = this.props,
      onChange = _this$props2.onChange,
      value = _this$props2.value;
    onChange(value, selectedColumns, invertSelection);
  }
  setInvertSelection(invertSelection) {
    var _this$props3 = this.props,
      onChange = _this$props3.onChange,
      value = _this$props3.value;
    onChange(value, [], invertSelection);
  }
  toggleColumn(name) {
    var _this$props4 = this.props,
      selectedColumns = _this$props4.selectedColumns,
      invertSelection = _this$props4.invertSelection;
    if (selectedColumns.includes(name)) {
      this.sendColumnChange(selectedColumns.filter(c => c !== name), invertSelection);
    } else {
      var update = selectedColumns.slice();
      update.push(name);
      this.sendColumnChange(update, invertSelection);
    }
  }
  selectAll() {
    this.setInvertSelection(true);
  }
  clear() {
    this.setInvertSelection(false);
  }
  selectNumbers() {
    var columns = this.props.columns;
    this.sendColumnChange(columns.filter(c => TableUtils.isNumberType(c.type)).map(column => column.name), false);
  }
  render() {
    var _this$props5 = this.props,
      value = _this$props5.value,
      selectedColumns = _this$props5.selectedColumns,
      invertSelection = _this$props5.invertSelection,
      columns = _this$props5.columns;
    var isConfigureColumnsShown = this.state.isConfigureColumnsShown;
    var hasAllColumnsSelected = selectedColumns.length === 0 && invertSelection === true || selectedColumns.length === columns.length && invertSelection === false;
    var hasNoColumnsSelected = selectedColumns.length === 0 && invertSelection === false || selectedColumns.length === columns.length && invertSelection === true;

    // set icon layers
    var icon;
    if (hasAllColumnsSelected) {
      // icon if all columns selected for search
      icon = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: dhSquareFilled,
          mask: dhGearFilled,
          transform: "shrink-2 down-5 right-7"
        }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: dhCheckSquare,
          className: "text-primary",
          transform: "shrink-4 down-5 right-7"
        })]
      });
    } else if (hasNoColumnsSelected) {
      // icon error, no columns selected for searching
      icon = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsCircleLargeFilled,
          mask: dhGearFilled,
          transform: "shrink-1 down-5 right-7"
        }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: dhWarningCircleFilled,
          className: "text-danger",
          transform: "shrink-4 down-5 right-7"
        })]
      });
    } else {
      // icon if some columns selected, but not all
      icon = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: dhSquareFilled,
          mask: dhGearFilled,
          transform: "shrink-2 down-5 right-7"
        }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: dhRemoveSquareFilled,
          className: "text-primary",
          transform: "shrink-4 down-5 right-7"
        })]
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "cross-column-container",
      children: [/*#__PURE__*/_jsx(SearchInput, {
        className: "cross-column-search",
        placeholder: "Search Data...",
        "data-testid": "cross-column-search",
        value: value,
        onChange: this.handleSearchValueChange,
        ref: this.searchField
      }), /*#__PURE__*/_jsxs("button", {
        type: "button",
        className: "btn btn-link btn-link-icon px-2",
        onClick: () => {
          if (isConfigureColumnsShown) {
            this.setState({
              isConfigureColumnsShown: false
            });
          } else {
            this.setState({
              isConfigureColumnsShown: true
            });
          }
        },
        children: [/*#__PURE__*/_jsx("div", {
          className: "fa-layers",
          children: icon
        }), /*#__PURE__*/_jsx(Tooltip, {
          children: "Configure Columns"
        }), /*#__PURE__*/_jsx(Popper, {
          isShown: isConfigureColumnsShown,
          className: "cross-column-popper",
          onExited: () => {
            this.setState({
              isConfigureColumnsShown: false
            });
          },
          closeOnBlur: true,
          interactive: true,
          children: /*#__PURE__*/_jsxs("div", {
            className: "cross-column-popup",
            children: ["Searched Columns", /*#__PURE__*/_jsx("div", {
              className: "cross-column-scroll",
              children: columns.map(column => {
                if (column.isProxy === true) return null;
                return /*#__PURE__*/_jsxs(React.Fragment, {
                  children: [/*#__PURE__*/_jsx(Checkbox, {
                    className: "cross-column-checkbox",
                    checked: invertSelection ? !selectedColumns.includes(column.name) : selectedColumns.includes(column.name),
                    onChange: () => this.toggleColumn(column.name),
                    children: column.name
                  }), column.type.substring(column.type.lastIndexOf('.') + 1)]
                }, column.name);
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "cross-column-button-bar",
              children: [/*#__PURE__*/_jsx("button", {
                type: "button",
                className: "btn btn-link",
                onClick: this.selectAll,
                children: "Select All"
              }), /*#__PURE__*/_jsx("button", {
                type: "button",
                className: "btn btn-link",
                onClick: this.clear,
                children: "Clear"
              }), /*#__PURE__*/_jsx("button", {
                type: "button",
                className: "btn btn-link",
                onClick: this.selectNumbers,
                children: "Numbers Only"
              })]
            }), hasNoColumnsSelected && /*#__PURE__*/_jsxs("p", {
              className: "text-danger",
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: dhWarningCircleFilled
              }), " Select at least one column to search."]
            })]
          })
        })]
      })]
    });
  }
}
export default CrossColumnSearch;
//# sourceMappingURL=CrossColumnSearch.js.map